export default __webpack_public_path__ + "991c1c761fc31f9c3252dbfb2a22fd7a.svg";